import React from 'react';
import { SettingsHubSection } from '../SettingsHubSection';

const ProjectDefaultsSettingsSection: React.FC = () => (
  <SettingsHubSection section="project-defaults" />
);

export default ProjectDefaultsSettingsSection;
